import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Activity } from "lucide-react";

export const Route = createFileRoute("/admin/administrateur/imaging/pacs/")({
  component: Page,
});

function Page() {
  return (
    <div className="space-y-4 p-6">
      <Link to="/admin/administrateur" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-3 w-3" /> Dashboard Administrateur
      </Link>
      <div>
        <div className="flex items-center gap-2 mb-1">
          
        </div>
        <h1 className="text-2xl font-bold tracking-tight">PACS</h1>
        <p className="mt-1 text-sm text-muted-foreground">Orthanc + dcm4chee · Stockage DICOM</p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Études totales</div><div className="mt-1 text-2xl font-bold text-emerald-400">24 891</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Stockage</div><div className="mt-1 text-2xl font-bold text-emerald-400">1.2 TB</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Compression</div><div className="mt-1 text-2xl font-bold text-emerald-400">-78%</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Rétention</div><div className="mt-1 text-2xl font-bold text-emerald-400">10 ans</div></CardContent></Card>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Détails PACS
          </CardTitle>
          <CardDescription>Module opérationnel · branché à l'API unifiée v7.1</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          <p>Page détaillée du module PACS. Les métriques sont collectées via OpenTelemetry et agrégées via Prometheus.</p>
        </CardContent>
      </Card>
    </div>
  );
}
